import { findPageDescriptorById } from './util.find-page-descriptor-by-id.js';

function findResourcePageTree(sitemap, pageDescriptor) {
  let currPageDescriptor = pageDescriptor;
  const pagesWithResources = [];
  while (currPageDescriptor !== void 0) {
    if (currPageDescriptor.hasResources) {
      pagesWithResources.push(currPageDescriptor);
    }
    if (currPageDescriptor.parentId && (currPageDescriptor.type === "Chapter" || currPageDescriptor.type === "ChapterGroup" || currPageDescriptor.type === "TeachersGuidePage")) {
      currPageDescriptor = findPageDescriptorById(
        sitemap,
        currPageDescriptor.parentId
      );
    } else {
      currPageDescriptor = void 0;
    }
  }
  return pagesWithResources;
}

export { findResourcePageTree };
//# sourceMappingURL=resource.get-page-tree.js.map
